/* eslint-disable jsx-a11y/alt-text */
import React, { useRef , useState ,useEffect }  from "react";
import ReactPlayer from "react-player";

import { Container, Row, Card, Col, CardDeck, Button } from 'react-bootstrap';

import { useHistory , Link} from 'react-router-dom';

import './CardMenuStyles.css' ;

import SliderCoverflowServ from '../../components/SliderCoverflow/SliderCoverflowServ';
import SliderCoverflowActi from '../../components/SliderCoverflow/SliderCoverflowActi';


import Message from '../Message/Message' 
import Loader from '../Loader/Loader' ;

import { listNewsflashs } from '../../actions/newsflashActions'

import  {useDispatch, useSelector} from 'react-redux'


const CardMenu = ({  history }) => { 


  const dispatch = useDispatch(); // Initialize dispatch hook

  const newsflashList = useSelector(state => state.newsflashList)
  const { loading, error, newsflashs } = newsflashList

  useEffect(() => {
      dispatch(listNewsflashs());
    }  , [dispatch]);



    const reactPlayerRef = useRef();


      //   const handleButtonClick = () => {
      //// Navigate to the specified page when the button is clicked
      //   history.push('/registerstagiaire');
      //};
  
    return (
        
    <Container >
        
    <h1 style={{color: 'red'}} >Formation Flash</h1>

    {loading ? <Loader />
                    : error ? <Message variant='danger'>{error}</Message>
                       : (
                        newsflashs.map(newsflash => (

     
     <div key={newsflash._id} class="card flex-row" style={{ width: '45rem', height: '12rem', marginBottom: '25px' }}>


      <img class="card-img-left example-card-img-responsive" 
           src={newsflash.link}
           style={{  height: "12.5rem"  }} />


      <div class="card-body" style={{ background: "#a8a7a7" ,height: "12.5rem"  }} >

        <Card.Title    style={{ color: "#ffffff"}} >{newsflash.titre}  </Card.Title>

        <Card.Text  style={{ color: "#ffffff"}} >         {newsflash.text}           <br/>     
          <Card.Link style={{ color: "#c90c0f"}} href="/catalog" >Voir plus</Card.Link> 
        </Card.Text>

        <Link to="/registerstagiaire">
        <Button variant="primary" style={{ background: "#c90c0f" }}>Inscription</Button>
        </Link>

      </div>
      
    </div>
    
))
)}


 

        </Container>
    )
}

export default CardMenu 
 